module.exports = __webpack_public_path__ + "assets/img/main.b6dbd5fe.jpg";